import { Flex, Heading, Icon, Text } from '@chakra-ui/react';
import { marketBriefingFakeData } from '@features/positions/marketBriefingFakeData';
import { useHref } from 'hooks/useHref';
import Link from 'next/link';
import { LuArrowRight } from 'react-icons/lu';

const MarketUpdateSummary = () => {
  const topMarketUpdate = marketBriefingFakeData[0];
  const { marketBriefingHref } = useHref();
  return (
    <Flex direction="column" gap={4}>
      <Heading fontSize="md">Market update</Heading>
      <Flex direction="column" gap={2}>
        <Heading fontSize="xl">{topMarketUpdate.title}</Heading>
        <Text fontSize="sm" color="text.secondary">
          {topMarketUpdate.content}
        </Text>
        <Text fontSize="xs" color="text.secondary">
          2d ago
        </Text>
        <Link href={marketBriefingHref()}>
          <Flex
            justify="space-between"
            align="center"
            p={2}
            _hover={{ bg: { base: 'gray.50', _dark: 'gray.800' } }}
            borderRadius="md"
            cursor="pointer"
          >
            <Text fontWeight="medium">Read today's stories</Text>
            <Icon as={LuArrowRight} />
          </Flex>
        </Link>
      </Flex>
    </Flex>
  );
};

export default MarketUpdateSummary;
